export default {
  en() {
    return {
      refundAmount: 'Refund Amount:',
      creditAmount: '2021 Event Credit Amount:',
      selected: 'Your Selection:',
      success: 'Success! Your selected option has been submitted.',
      docusignFinePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      gracias: 'Thank you!',
      step1: 'Step 1:',
      step1Description: 'Make Your Selection',
      optionSelect: 'Select Your Option',
      step2: 'Step 2:',
      step2Description: 'Sign Terms and Conditions',
      clickHere: 'Click here',
      clickHereDescription: 'to read and agree to your terms and conditions.',
      submit: 'Save & Submit',
    }
  },

  enGB() {
    return {
      refundAmount: 'Refund Amount:',
      creditAmount: '2021 Event Credit Amount:',
      selected: 'Your Selection:',
      success: 'Success! Your selected option has been submitted.',
      docusignFinePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      gracias: 'Thank you!',
      step1: 'Step 1:',
      step1Description: 'Make Your Selection',
      optionSelect: 'Select Your Option',
      step2: 'Step 2:',
      step2Description: 'Sign Terms and Conditions',
      clickHere: 'Click here',
      clickHereDescription: 'to read and agree to your terms and conditions.',
      submit: 'Save & Submit',
    }
  },

  ar() {
    return {
      refundAmount: 'Refund Amount:',
      creditAmount: '2021 Event Credit Amount:',
      selected: 'Your Selection:',
      success: 'Success! Your selected option has been submitted.',
      docusignFinePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      gracias: 'شكرا لك!',
      step1: 'الخطوة الأولي:',
      step1Description: 'Make Your Selection',
      optionSelect: 'Select Your Option',
      step2: 'الخطوة الثانية:',
      step2Description: 'Sign Terms and Conditions',
      clickHere: 'Click here',
      clickHereDescription: 'to read and agree to your terms and conditions.',
      submit: 'Save & Submit',
    }
  },

  it() {
    return {
      refundAmount: 'Importo del rimborso:',
      creditAmount: 'Importo dei crediti per l\'evento del 2021:',
      selected: 'La tua selezione:',
      success: 'Vittoria! L\'opzione selezionata è stata inviata.',
      docusignFinePrint: 'Questo collegamento ti indirizzerà a docusign.com. Una volta presa visione dei termini e delle condizioni, verrai reindirizzato a questa pagina per il completamento dell\'acquisto.',
      gracias: 'Grazie!',
      step1: 'Primo passaggio:',
      step1Description: 'fa\' la tua scelta',
      optionSelect: 'Scagli un\'opzione',
      step2: 'Secondo passaggio:',
      step2Description: 'sottoscrivi termini e condizioni',
      clickHere: 'Clicca qui',
      clickHereDescription: 'per leggere e accettare i termini e le condizioni.',
      submit: 'Salva e invia',
    }
  },

  fr() {
    return {
      refundAmount: 'Montant du remboursement:',
      creditAmount: 'Montant de l\'avoir pour l\'événement 2021:',
      selected: 'Votre sélection:',
      success: 'Votre choix a été enregistré et envoyé avec succès!',
      docusignFinePrint: 'Ce lien vous dirigera vers le site docusign.com. Une fois que vous aurez signé ces termes et conditions, vous serez redirigé vers cette page pour finaliser votre achat.',
      gracias: 'Merci!',
      step1: 'Étape 1:',
      step1Description: 'Faites votre choix',
      optionSelect: 'Sélectionnez votre option',
      step2: 'Étape 2:',
      step2Description: 'Signez les Termes et Conditions',
      clickHere: 'Veuillez cliquer',
      clickHereDescription: 'ici pour lire et accepter nos termes et conditions.',
      submit: 'Enregistrer & Envoyer',
    }
  },

  ja() {
    return {
      refundAmount: '払い戻し金額：',
      creditAmount: '2021年イベントクレジット額：',
      selected: 'あなたの選択：',
      success: '成功！選択オプションが送信されました。',
      docusignFinePrint: 'このリンクをクリックすると、docusign.comに移動します。契約条件への署名が完了すると、このページに戻って購入を完了します。',
      gracias: 'ありがとうございます!',
      step1: 'ステップ 1:',
      step1Description: '選択する',
      optionSelect: 'オプションを選択してください',
      step2: 'ステップ 2:',
      step2Description: '利用契約に署名する',
      clickHere: 'こちらをクリックして、',
      clickHereDescription: '利用規約を読み、同意してください。',
      submit: '保存して送信',
    }
  },

  de() {
    return {
      refundAmount: 'Rückerstattungsbetrag:',
      creditAmount: '2021 Event-Guthabenbetrag:',
      selected: 'Ihre Wahl:',
      success: 'Erfolg! Ihre gewählte Option wurde übermittelt.',
      docusignFinePrint: 'Dieser Link führt Sie zu docusign.com. Nach der Unterzeichnung der Allgemeinen Geschäftsbedingungen werden Sie auf diese Seite zurückgeleitet, um Ihren Kauf abzuschließen.',
      gracias: 'Vielen Dank!',
      step1: 'Schritt 1:',
      step1Description: 'Treffen Sie Ihre Wahl',
      optionSelect: 'Wählen Sie Ihre Option',
      step2: 'Schritt 2:',
      step2Description: 'Unterschreiben Sie die Allgemeinen Geschäftsbedingungen',
      clickHere: 'Klicken Sie hier,',
      clickHereDescription: 'um unsere AGB zu lesen und zu akzeptieren.',
      submit: 'Speichern & Übermitteln',
    }
  },

  esMX() {
    return {
      refundAmount: 'Cantidad del Reembolso:',
      creditAmount: 'Cantidad del Crédito del Evento 2021:',
      selected: 'Su Selección:',
      success: '¡Éxito! Su opción seleccionada ha sido enviada.',
      docusignFinePrint: 'Este enlace lo llevará a docusign.com. Una vez que haya firmado sus términos y condiciones, volverá a esta página para completar su compra.',
      gracias: 'Gracias',
      step1: 'Paso 1:',
      step1Description: 'Haga Su Selección',
      optionSelect: 'Seleccione Su Opción',
      step2: 'Paso 2:',
      step2Description: 'Firme los Términos y Condiciones',
      clickHere: 'Haga clic aquí',
      clickHereDescription: 'para leer y aceptar nuestros términos y condiciones.',
      submit: 'Guardar & Enviar',
    }
  },

  zhCN() {
    return {
      refundAmount: '退款金额：',
      creditAmount: '2021年活动积分额度：',
      selected: '您的选择：',
      success: '成功！您选择的选项已提交。',
      docusignFinePrint: '点击该链接可访问docusign.com网站。同意条款和条件后，您将返回此页面以完成支付。',
      gracias: '谢谢！',
      step1: '第一步:',
      step1Description: '选择',
      optionSelect: '选择您的选项',
      step2: '第二步:',
      step2Description: '签署条款和条件',
      clickHere: '点击此处',
      clickHereDescription: '读并同意我们的条款和条件。',
      submit: '保存并提交',
    }
  },

  // PL needs just about everything
  pl() {
    return {
      refundAmount: 'Refund Amount:',
      creditAmount: '2021 Event Credit Amount:',
      selected: 'Your Selection:',
      success: 'Success! Your selected option has been submitted.',
      docusignFinePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      gracias: 'Dziękuję!',
      step1: 'krok 1:',
      step1Description: 'Make Your Selection',
      optionSelect: 'Select Your Option',
      step2: 'krok 2',
      step2Description: 'Sign Terms and Conditions',
      clickHere: 'Click here',
      clickHereDescription: 'to read and agree to our terms and conditions.',
      submit: 'Save & Submit',
    }
  }
}
